<template>
  <div class="aui-content">
    <header class="aui-bar aui-bar-nav">
      <router-link class="aui-pull-left aui-btn" to="/purchasing">
        <span class="aui-iconfont aui-icon-left"></span>
      </router-link>
      <div class="aui-title">详细</div>
    </header>
    <ul class="aui-list aui-media-list maui-detail-list">
      <li class="aui-list-item">
        <!-- 轮播图 -->
        <div>
          <div class="scrhome">
            <van-swipe
              class="my-swipe"
              @change="onChange"
              :loop="false"
              :initial-swipe="initialswip"
            >
              <van-swipe-item v-for="(item, i) in  pictureUrls" :key="i" @click="ab">
                <img :src="item.url" alt />
              </van-swipe-item>

              <div
                class="custom-indicator definearr"
                slot="indicator"
              >{{ current + 1 }}/{{picnumber}}</div>
            </van-swipe>

            <van-image-preview
              v-model="show"
              :images="imagesa"
              @change="onChangae"
              :startPosition="startp"
            >
              <template v-slot: index>{{ index+1 }}/{{picnumber}}</template>
            </van-image-preview>
          </div>
        </div>
        <!-- 轮播图 end-->
        <!-- <div class="maui_imgbox">
				<div><img src="../assets/img2.jpg"></div>
				<div><img src="../assets/img2.jpg"></div>
				<div class="maui-nobox">1 / 5</div>
        </div>-->
        <div class="aui-media-list-item-inner battery-supfoet">
          <div class="aui-list-item-inner">
            <div class="aui-list-item-text">
              <div class="aui-list-item-title">{{title}} {{number}}{{unit}}</div>
            </div>
            <div class="maui-list-item">
              <div class="aui-label maui-label-green">{{goodsClassName}}</div>
            </div>
            <div class="aui-list-item-text maui-price-text">
              <div v-if="estimatedPrice!=''">
                <!-- <img src="../assets/img2.jpg"> -->
                ￥
                <span>{{estimatedPrice}}</span>
              </div>
              <div v-else>期望价格：面谈</div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div class="aui-content maui-info-textbox">
      <h2>基本信息</h2>
      <ul class="aui-list aui-form-list" v-for="(item,i) in arr" :key="i">
        <li class="aui-list-item">
          <div class="aui-list-item-inner">
            <div class="aui-list-item-label">{{item.name}}</div>
            <div class="aui-list-item-input">
              <input
                type="text"
                v-for="(item, index) in item.infoList"
                :key="index"
                v-model="item.name"
                readonly
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="aui-content maui-info-textbox">
      <h2>公司信息</h2>
      <div v-if="companyList!== undefined &&companyList.length>0">
        <div v-for="(items,i) in companyList" :key="i" class="battery-suppplyform-companyinfor">
          <div v-if="items.name">
            <p>公司名称</p>
            <span>{{items.name}}</span>
          </div>
          <div v-if="items.address">
            <p>公司地址</p>
            <span>{{items.address}}</span>
          </div>
          <div v-if="items.master">
            <p>联系人</p>
            <span>{{items.master}}</span>
          </div>
          <div v-if="items.phone">
            <p>联系电话</p>
            <span>{{items.phone}}</span>
          </div>
          <div v-else>
            <p>联系电话</p>
            <span>
              <a href="https://www.wukuangxunhuan.net/cswx/mobile/register/info">联系方式注册后可见</a>
            </span>
          </div>
          <div v-if="items.rTypeName">
            <p>公司类型</p>
            <span>{{items.rTypeName}}</span>
          </div>
        </div>
      </div>
      <div v-else></div>
    </div>
    <div class="aui-content maui-info-textbox">
      <h2>信息描述</h2>
      <div class="maui-textbox">
        <div class="battery-detail-cctoe" v-html="content">{{content}}</div>
      </div>
    </div>
    <div class="aui-content maui-info-textbox">
      <div class="battery-s-code"><img src="/static/image/ptLogo.jpg" alt= /></div>
    </div>
  </div>
</template>
 
<script>
import $ from "jquery";
import wechat from "../../static/js/wechat1.js";
export default {
  name: "ScrollerOne",
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      arr: [],
      showPage: 1,
      pageSize: 4,
      xqid: "",
      id: "",
      content: "",
      unit: "",
      goodsClassName: "",
      pictureUrl: "",
      companyList: [],
      speciDetailList: "",
      pictureUrls: "",
      estimatedPrice: "",
      title: "",
      number: "",
      current: 0,
      show: false,
      index: 0,
      picnumber: 0,
      imagesa: [],
      startp: 0,
      initialswip: 0,
      companyshow: false,
      code: "",
      nowurl: "",
      APPID: "wxda9fc843afddd541",
      openidn: "",
      codenew: "",
      option: {}
    };
  },
  mounted() {
    //this.getData();
    //this.url();
    this.authority();
  },
  methods: {
    //请求至服务端计数器
    supplycount() {
      this.$Axios
        .get("/changsha/f/hit/hitCount", {
          params: {
            id: this.id,
            sign: "need"
          }
        })
        .then(res => {
          console.log("请求计数器:" + res);
          if (res.status === 200) {
            return res.data;
          } else {
            return "error";
          }
        })
        .catch(error => {
          console.log("this is error" + error);
        });
    },
    url() {
      this.nowual = window.location.href;
      console.log("当前路径：" + this.nowual);
    },
    url() {
      this.nowual = window.location.href;
      console.log("当前路径：" + this.nowual);
    },
    authority() {
      let code = this.getQueryString("code");
      console.log("第一个函数：" + code);
      if (!code) {
        this.getWxCode();
      } else {
        this.getOpenId(code);
      }
    },
    getQueryString(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getWxCode() {
      var nowUrl = window.location.href;
      nowUrl = encodeURIComponent(nowUrl);
      var url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.APPID +
        "&redirect_uri=" +
        nowUrl +
        "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";

      location.href = url;
    },
    getOpenId(code) {
      console.log("getOpenid函数：", code);
      let _this = this;
      this.codenew = code;
      let openId = sessionStorage.getItem("openId");
      if (!openId) {
        var param = {
          url: "/wx/mobile/service/getOpenId"
        };
        this.$axios
          .get("https://www.wukuangxunhuan.net/cswx/mobile/service/getOpenId", {
            params: {
              code: this.codenew
            }
          })
          .then(function(json) {
            console.log(json);
            if (json) {
              //openId = json.data.openId;
              //console.log("json.data" + json.data);
              //console.log("json.data.openId" + json.data.openId);
              //this.openidn = json.data.openId;
              if (json.data.openId) {
                sessionStorage.setItem("openId", json.data.openId);
                _this.getData(json.data.openId);
              }
            }
          });
      } else {
        this.getData(openId);
      }
    },
    onChange(index) {
      this.current = index;
    },
    onChangae(index) {
      this.index = index;
      this.initialswip = this.index;
      this.current = this.initialswip;
    },
    ab() {
      this.startp = this.current;
      this.show = true;
    },
    getData(name) {
      this.xqid = this.$route.query.xqid;
      this.openidn = name;
      console.log("_+_+_+_+_+" + this.xqid);
      // Axios.get('http://gank.io/api/data/%E7%A6%8F%E5%88%A9/5/1').then((response) => {
      //http://gank.io/api/data/%E7%A6%8F%E5%88%A9/' + that.pageSize + '/' + that.showPage
      this.$axios
        .get(
          "/micro/permission_order-view//need/read/needWXInfo?id=" +
            this.xqid +
            "&openId=" +
            this.openidn
        )
        .then(res => {
          this.id = res.data.data.id;
          this.companyList = res.data.data.companyList;
          this.unit = res.data.data.unit;
          this.arr = res.data.data.speciDetailList;
          this.pictureUrls = res.data.data.pictureUrls;

          console.log(this.pictureUrls);
          let imgUrl = "";
          for (var i = 0; i < this.pictureUrls.length; i++) {
            if (i == 0) {
              imgUrl = this.pictureUrls[i].url;
            }
            this.imagesa.push(this.pictureUrls[i].url);
          }
          console.log(this.imagesa);
          this.picnumber = this.imagesa.length;
          this.content = res.data.data.content;
          this.estimatedPrice = res.data.data.estimatedPrice;
          this.title = res.data.data.title;
          this.number = res.data.data.number;
          this.goodsClassName = res.data.data.goodsClassName;
          this.option = {
            title: "求购：" + this.title,
            imgUrl: imgUrl,
            link: location.href.replace(/&code=[^&]*/, "")
          };
          wechat.share(this.option);
          // this.supplycount();
        })
        .catch(error => {
          console.log(error);
          //没网的时候，或者接口调用异常的时候
          // this.$refs.myscroller.finishInfinite(true);//这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
        });
    }
  }
};
</script>
 
<style >
.battery-s-code {
  text-align: center;
}
.battery-s-code > img {
  margin: 0 auto;
  width: 90%;
}
.battery-suppplyform-companyinfor > div span {
  display: block;
  margin-left: 100px;
}
.battery-suppplyform-companyinfor > div p {
  position: absolute;
  left: 20px;
  top: 10px;
}
.battery-suppplyform-companyinfor > div {
  border-bottom: solid 1px #f0f0f0;
  font-size: 0.7rem;
  padding: 13px 20px;
  color: #858484;
  position: relative;
}
.battery-suppplyform-companyinfor span {
  color: #424242;
}
.battery-supfoet {
  margin-top: 10px;
}
.scrhome {
  position: relative;
  background: #d8d7d7;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;

  text-align: center;
}
.scrhome img {
  height: 100% !important;
  margin: 0 auto;
}
.van-image-preview__overlay {
  background-color: rgba(0, 0, 0, 1) !important;
}
.container {
  display: flex;
  width: 375px;
  height: 100%;
  /* background: red; */
  flex-direction: column;
}
.definearr {
  position: absolute;
  right: 0px;
  bottom: 14px;
  padding: 3px 20px 3px 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-weight: 400 !important;
  border-radius: 15px 0px 0px 15px;
}
img {
  max-width: 95%;
  display: inline-block;
  text-align: center;
  max-height: 200px;
}
.itemStyle {
  display: flex;
  width: 375px;
  height: 100px;
  /* background: coral;
    border: 1px blue solid; */
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchasingform.vue